import styled from "styled-components";

export const NotificationButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
`;

export const NotificationButtonIcon = styled.div`
	position: relative;

	/* &::after {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		background: #ff0303;
		border-radius: 50%;
		transition: all 0.3s ease-in-out;
		opacity: 0;
	} */

	/* ${props => props.showIndicator && `
		&:after {
			width: 9px;
			height: 9px;
			opacity: 1;
		}
	`} */
`;

export const NotificationsTotalBadge = styled.div`
		background: #ff0303;
		border-radius: 50%;
		color: #fff;
		font-size: 9px;
		font-weight: 600;
		height: 18px;
		line-height: 18px;
		position: absolute;
		right: -5px;
		top: -5px;
		width: 18px;
`;


export const NotificationLoading = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
`;
export const NotificationContainer = styled.div`
	width: 380px;
	padding: 1rem 0;
`;
export const NotificationList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding-bottom: 1rem;
`;
export const NotificationItem = styled.div`
	display: flex;
	gap: 1rem;
	padding: 1rem;
	cursor: pointer;
	border-radius: 5px;


	background-color: ${(props) => (props.read ? 'transparent' : '#f5f5f5')};
`;
export const NotificationAvatar = styled.div`
	width: 40px;
	height: 40px;
	position: relative;

	&::after {
		content: "";
		position: absolute;
		top: 1px;
		right: 1px;
		background: #ff0303;
		border-radius: 50%;
		transition: all 0.3s ease-in-out;
		opacity: 0;
	}

	${props => props.showIndicator && `
		&:after {
			width: 11px;
			height: 11px;
			opacity: 1;
		}
	`} 
`;
export const NotificationAvatarImage = styled.img`
	width: 100%;
	height: 100%;
	border-radius: 50%;
`;
export const NotificationContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	flex: 1;
`;
export const NotificationContentInfo = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: #002e5c;
	display: flex;
	flex-wrap: wrap;
	gap: 0.25rem;
`;
export const NotificationContentAddedBy = styled.div`
	font-size: 12px;
	font-weight: 400;
	color: #7e8299;
	display: flex;
	flex-wrap: wrap;
	gap: 0.25rem;
`;
export const NotificationContentName = styled.div`
	font-weight: 600;
	color: #002e5c;
`;
export const NotificationContentNew = styled.div`
	background-color: rgb(37 85 239 / 20%);
	color: #2555ef;
	border-radius: 5px;
	height: 20px;
	width: 42px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 600;
`;
export const NotificationContentDate = styled.div`
	font-size: 12px;
	font-weight: 400;
	color: rgb(0 46 92 / 50%);
`;

export const NotificationPeriod = styled.div`
	font-size: 14px;
	color: #b5b5c3;
	margin: 2rem 0;
`;

export const NotificationHeder = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem 1rem 1rem 1rem;
	border-bottom: 1px solid #e5e5e5;
	margin-bottom: 1rem;
`;
export const AddNotifyButton = styled.div`
	    display: flex;
    align-items: center;
    gap: 5px;
    color: #2555ef;
    font-weight: 500;
    cursor: pointer;
`



export const AddNotifyContainer = styled.div`
	min-width: 500px;
	min-height: 500px;
	padding: 2rem;
`;

export const AddNotifyTitle = styled.h1`
	font-family: var(--LayoutAddNotifyTitleFont-family);
	font-style: normal;
	font-weight: 500;
	font-size: 24px;
	line-height: 32px;
	text-align: center;
`

export const AddNotifyContent = styled.div`
	margin-top: 2rem;

`;

export const AddNotifyFormGroup = styled.div``;
export const AddNotifyActions = styled.div``;
export const AddNotifyActionsBtn = styled.div``;
export const NotificationActions = styled.div``;
export const NotificationActionsPrimaryBtn = styled.button`
		width: 100px;
    height: 36px;
    border-radius: 5px;
    background: #2555ef;
`;

export const NotificationActionsSecondaryBtn = styled.button`
		width: 120px;
    height: 36px;
    border-radius: 5px;
		background: transparent;
    border: 1px solid #2555ef;
		color: #2555ef;
		display: flex;
		align-items: center;
		justify-content: center;

		&:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
`;